
export default class LocationWebsite {
    constructor(id, cscom) {
        if (!(this instanceof LocationWebsite)) {
            return new LocationWebsite(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/locations-websites/${this.id}`;
        } else {
            this.path = `/user-site-api/locations-websites`;
        }
    }

    listAll() {
        return this.cscom.req.get(this.path, { limit: 9999 }).then((result) => {
            return result._embedded.items;
        });
    }
    
    get(data) {
        return this.cscom.req.get(this.path, null, data);
    }

    list(data) {
        return this.cscom.req.get(this.path, data);
    }

    update(body) {
        return this.cscom.req.put(this.path, body).then((result) => {
            return result;
        });
    }

    add(body) {
        return this.cscom.req.post(this.path, body).then((result) => {
            return result;
        });
    }


    remove() {
        return this.cscom.req.del(this.path).then((result) => {
            return result;
        });
    }

}    
